import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteAssessmentItemDriverMetricQuantityMutation, deleteAssessmentItemDriverMetricQuantityMutationVariables } from '../generated/deleteAssessmentItemDriverMetricQuantityMutation';
import { assessmentItemDriverMetricQuantityFieldsFragment } from '../models/AssessmentItemDriverMetricQuantity';

/**
 * Get a callback to delete a AssessmentItemDriverMetricQuantity in the store.
 */
export function useDeleteAssessmentItemDriverMetricQuantityCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteAssessmentItemDriverMetricQuantityMutation, deleteAssessmentItemDriverMetricQuantityMutationVariables>(
        gql`
            mutation deleteAssessmentItemDriverMetricQuantityMutation ($id: ID!) {
                deleteAssessmentItemDriverMetricQuantity(id: $id) {
                    ...assessmentItemDriverMetricQuantityFields
                }
            }

            ${assessmentItemDriverMetricQuantityFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
